import template from './branch_management.html';
import controller from './branch_management.controller';
import './branch_management.scss';

let branchManagementComponent = {
  restrict: 'E',
  bindings: {
  },
  template,
  controller
};

export default branchManagementComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/branch_management.component.js